module.exports = {
    isBrowser: () => {
        return (typeof window !== 'undefined')
    }
}
